import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PublicEventEditDetail from '../components/pubevent/PublicEventEditDetail';
import { translate } from "react-i18next";
import '../css/style.css';
import '../components/Home.css';
import {  WEB_URL } from '../backend/Backend';
import {  Row, Col } from 'react-bootstrap';
import Sharing from "../components/util/Sharing";


class PublicEventEditLayout extends Component {

    constructor(props) {
        super(props);
    
    
        this.state = {
            eventDetail:{}
        };
      }

    render(){
        const { t } = this.props;
        const { params } = this.props.match
        let url=WEB_URL + "showevent/" + params.id;
         return (<SimpleLayout title={t("publicEventEdit")}  eventKey="2">
             <div>
               <PublicEventEditDetail eventId= {params.id} />
               <hr className="mt-5 " />
                <Row>
                   <Col lg={2} className="mt-2"  >
                       <a href={`${url}`} data-href={`${url}DATA`} role="link" tabindex="1" target="_blank" data-channel="twitter" className="ml-2  "   >
                       <i className="text-primary fa fa-globe s16  mr-2 " ></i>{t("goToPublicEvent")}</a>
                    </Col>
                  
                    <Col lg={10} className=" float-left">
                        <Sharing url={url}  shareLabel={true} facebook={true} twitter={true} />
                    </Col>

                   
                    
                  
                </Row>
                </div>
           </SimpleLayout>)
       }

}

export default translate("translations")(PublicEventEditLayout);